@if (summary$ | async; as summary) {
    <span class="linear-container-possible-winnings__label">{{ messages.linear.ToReturn }}</span>
    @if (summary.originalWinnings) {
        <span class="linear-container-possible-winnings__value--original"> {{ summary.originalWinnings | bsCurrency: true }}</span>
    }
    <span class="linear-container-possible-winnings__value"> {{ getPossibleWinningsValue(summary) | bsCurrency: true }}</span>
}
